import { Drawer } from 'vaul';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Bottom sheet (mobile) e drawer lateral (desktop). Na Fase 4 vira o drawer de tarefa. */
export function Sheet({
  open,
  onOpenChange,
  title,
  side = 'bottom',
  children,
  className,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title: string;
  side?: 'bottom' | 'left' | 'right';
  children: ReactNode;
  className?: string;
}) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange} direction={side}>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-50 bg-black/60" />
        <Drawer.Content
          className={cn(
            'fixed z-50 flex flex-col bg-stage outline-none',
            side === 'bottom' &&
              'inset-x-0 bottom-0 max-h-[88dvh] rounded-t-[20px] pb-[env(safe-area-inset-bottom)]',
            side === 'left' && 'inset-y-0 left-0 w-[min(300px,86vw)] rounded-r-[20px]',
            side === 'right' && 'inset-y-0 right-0 w-[min(520px,100vw)] rounded-l-[20px]',
            className,
          )}
        >
          {side === 'bottom' && <div className="mx-auto mt-2.5 h-1 w-10 rounded-full bg-line-strong" />}
          <Drawer.Title className="sr-only">{title}</Drawer.Title>
          <Drawer.Description className="sr-only">{title}</Drawer.Description>
          {children}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
